import { render, staticRenderFns } from "./OwnerAccessCodeList.vue?vue&type=template&id=8834ff86&"
import script from "./OwnerAccessCodeList.vue?vue&type=script&lang=ts&"
export * from "./OwnerAccessCodeList.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerAccessCodeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports